import { Tooltip, TooltipProps } from "@p0security/ui";
import { ReactNode } from "react";
import { stopPropagation } from "utils/javascript";

export const GraphTooltip: React.FC<{ width?: string } & TooltipProps> = (
  props
) => {
  const { children, title, width, ...tooltipProps } = props;

  return (
    <Tooltip
      {...tooltipProps}
      title={<div onClick={stopPropagation}>{title as ReactNode}</div>}
      styles={{
        body: { width, color: "#000000", fontSize: "13px" },
      }}
      color="#ffffff"
    >
      <span className="inline-block max-w-full">{children}</span>
    </Tooltip>
  );
};
